import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const STATS = ["height", "bust", "waist", "hips", "shoes"];

export const ModelCard = ({ model, index = 0 }) => (
  <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.7, delay: (index % 5) * 0.06, ease: [0.22, 1, 0.36, 1] }}>
    <Link to={`/models/${model.slug}`} data-testid={`model-card-${model.slug}`} className="group block">
      <div className="relative aspect-[2/3] overflow-hidden bg-[#eeeeee]">
        {model.images?.[0] && (
          <img src={model.images[0]} alt={model.name} loading="lazy"
            className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.06]" />
        )}
        <div className="absolute inset-0 flex flex-col justify-end bg-[#1c1418]/80 p-4 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
          {STATS.map((k) => (
            <div key={k} className="flex justify-between border-b border-white/20 py-1.5 font-mono text-[11px] uppercase tracking-[0.15em] text-white">
              <span className="text-white/70">{k}</span><span>{model.measurements?.[k]?.split(" - ")[0] || "—"}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-baseline justify-between gap-2 pt-3">
        <h3 className="font-display text-2xl uppercase leading-none tracking-tight transition-colors group-hover:text-[#1c1418]/70 md:text-3xl">{model.name}</h3>
        <span className="font-mono text-[11px] text-[#1c1418]/60">{model.measurements?.height?.split(" - ")[0]}</span>
      </div>
    </Link>
  </motion.div>
);
